import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { Query as RootQuery } from 'graphql/models/generated';

export const VALUE_TEXTS_QUERY = gql`
query valueTexts(
  $type: ValueTextType!,
  $language: String!,
  $values: [ValueTextsInput!]
) {
  valueTexts(
    type: $type,
    language: $language,
    values: $values
  ) {
    values {
      text
      fullId
    }
  }
}
`;

@Injectable({
  providedIn: 'root'
})
export class ValueTextsQuery extends Query<RootQuery> {
  document = VALUE_TEXTS_QUERY;
}
